export default __webpack_public_path__ + "static/media/3.0f6d31e5.png";